import type { OrderSettingsDropdown } from '@/api/models/OrderSettings';
import { getRequest } from '../services/requestHandler';

export const getNotificationEventTypeForDropdown = (notificationTypeId: number) =>
  getRequest<OrderSettingsDropdown>('GetNotificationEventTypeForDropdown', `notification/GetNotificationEventTypeForDropdown?notificationTypeId=${notificationTypeId}&activeOnly=true`);
